import React, { Component } from "react";
import ProjectTable from "../../components/ProjectTable/ProjectTable";
import Modal from "../../hoc/UI/Modal/Modal";
import Aux from "../../hoc/Auxilary";
import ProjectModal from "../../components/ProjectModal/ProjectModal";
import axiosInstance from "../../axios-project";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const userID = localStorage.getItem("id");

const confirmBeforeDelete = fn => {
  swal({
    title: "Are you sure?",
    text: "Once deleted, this operation cannot be undone!",
    icon: "warning",
    buttons: true,
    dangerMode: true
  }).then(willDelete => {
    if (willDelete) {
      fn();
    }
  });
};

class ProjectOverview extends Component {
  state = {
    procurement: null,
    stakeholder: [],
    mode: Number.parseInt(localStorage.getItem("project_mode") || 3),
    projectDetails: [],
    projectDocuments: [],
    baseURL: "https://api.transportationprojects.org/api",
    showModal: false,
    showSmallModal: false,
    currentProjectID: null,
    newProjectMode: true,
    page: 0,

    implementationActualCost: [],
    implementationDesignConstructionCost: [],
    implementation: [],

    devP3AlternativeCost: [],
    devP3BpscCost: [],

    aadt: [],
    dbe: [],
    cost: [],
    news: [],
    contract: [],
    contractATC: [],
    contractClaim: [],
    contractDBE: [],
    contractWorkZone: [],
    contractChangeOrder: [],
    contractQualityAssurance: [],
    devFeisCostEstimate: [],
    devEnvironmentReview: []
    //#insert point: array definition
  };

  //#insert point: http request

  /*
 DevEnvironmentReview
  */

  changeModeHandler = modeID => {
    this.setState({
      mode: modeID
    });
    localStorage.setItem("project_mode", modeID);
  };

  changePage = p => {
    this.setState({
      page: p
    });
  };

  fetchDevEnvironmentReview = () => {
    axiosInstance
      .get(
        "/proj_dev_enviornment_review/project_id/" + this.state.currentProjectID
      )
      .then(response => {
        this.setState({
          devEnvironmentReview: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addDevEnvironmentReviewHandler = devEnvironmentReview => {
    axiosInstance
      .post("/proj_dev_enviornment_review", devEnvironmentReview)
      .then(response => {
        this.fetchDevEnvironmentReview();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDevEnvironmentReviewHandler = devEnvironmentReview => {
    axiosInstance
      .put(
        "/proj_dev_enviornment_review/" +
          devEnvironmentReview.proj_dev_enviornment_review_id,
        devEnvironmentReview
      )
      .then(response => {
        this.fetchDevEnvironmentReview();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteDevEnvironmentReviewHandler = proj_dev_enviornment_review_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete(
          "./proj_dev_enviornment_review/" + proj_dev_enviornment_review_id
        )
        .then(response => {
          this.fetchDevEnvironmentReview();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
 DevFeisCostEstimate
  */

  fetchDevFeisCostEstimate = () => {
    axiosInstance
      .get(
        "/proj_dev_feis_cost_estimate/project_id/" + this.state.currentProjectID
      )
      .then(response => {
        this.setState({
          devFeisCostEstimate: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addDevFeisCostEstimateHandler = devFeisCostEstimate => {
    axiosInstance
      .post("/proj_dev_feis_cost_estimate", devFeisCostEstimate)
      .then(response => {
        this.fetchDevFeisCostEstimate();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDevFeisCostEstimateHandler = devFeisCostEstimate => {
    axiosInstance
      .put(
        "/proj_dev_feis_cost_estimate/" +
          devFeisCostEstimate.proj_dev_feis_cost_estimate_id,
        devFeisCostEstimate
      )
      .then(response => {
        this.fetchDevFeisCostEstimate();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteDevFeisCostEstimateHandler = proj_dev_feis_cost_estimate_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete(
          "./proj_dev_feis_cost_estimate/" + proj_dev_feis_cost_estimate_id
        )
        .then(response => {
          this.fetchDevFeisCostEstimate();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
 ContractQualityAssurance
  */

  fetchContractQualityAssurance = () => {
    axiosInstance
      .get(
        "/proj_contract_quality_assurance/project_id/" +
          this.state.currentProjectID
      )
      .then(response => {
        this.setState({
          contractQualityAssurance: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addContractQualityAssuranceHandler = contractQualityAssurance => {
    axiosInstance
      .post("/proj_contract_quality_assurance", contractQualityAssurance)
      .then(response => {
        this.fetchContractQualityAssurance();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateContractQualityAssuranceHandler = contractQualityAssurance => {
    axiosInstance
      .put(
        "/proj_contract_quality_assurance/" +
          contractQualityAssurance.proj_contract_quality_assurance_id,
        contractQualityAssurance
      )
      .then(response => {
        this.fetchContractQualityAssurance();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteContractQualityAssuranceHandler = proj_contract_quality_assurance_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete(
          "./proj_contract_quality_assurance/" +
            proj_contract_quality_assurance_id
        )
        .then(response => {
          this.fetchContractQualityAssurance();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
 ContractChangeOrder
  */

  fetchContractChangeOrder = () => {
    axiosInstance
      .get(
        "/proj_contract_change_order/project_id/" + this.state.currentProjectID
      )
      .then(response => {
        this.setState({
          contractChangeOrder: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addContractChangeOrderHandler = contractChangeOrder => {
    axiosInstance
      .post("/proj_contract_change_order", contractChangeOrder)
      .then(response => {
        this.fetchContractChangeOrder();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateContractChangeOrderHandler = contractChangeOrder => {
    axiosInstance
      .put(
        "/proj_contract_change_order/" +
          contractChangeOrder.proj_contract_change_order_id,
        contractChangeOrder
      )
      .then(response => {
        this.fetchContractChangeOrder();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteContractChangeOrderHandler = proj_contract_change_order_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./proj_contract_change_order/" + proj_contract_change_order_id)
        .then(response => {
          this.fetchContractChangeOrder();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
 ContractWorkZone
  */

  fetchContractWorkZone = () => {
    axiosInstance
      .get("/proj_contract_work_zone/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          contractWorkZone: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addContractWorkZoneHandler = contractWorkZone => {
    axiosInstance
      .post("/proj_contract_work_zone", contractWorkZone)
      .then(response => {
        this.fetchContractWorkZone();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateContractWorkZoneHandler = contractWorkZone => {
    axiosInstance
      .put(
        "/proj_contract_work_zone/" +
          contractWorkZone.proj_contract_work_zone_id,
        contractWorkZone
      )
      .then(response => {
        this.fetchContractWorkZone();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteContractWorkZoneHandler = proj_contract_work_zone_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./proj_contract_work_zone/" + proj_contract_work_zone_id)
        .then(response => {
          this.fetchContractWorkZone();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
 ContractDBE
  */

  fetchContractDBE = () => {
    axiosInstance
      .get("/project_contract_dbe/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          contractDBE: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addContractDBEHandler = contractDBE => {
    axiosInstance
      .post("/project_contract_dbe", contractDBE)
      .then(response => {
        this.fetchContractDBE();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateContractDBEHandler = contractDBE => {
    axiosInstance
      .put(
        "/project_contract_dbe/" + contractDBE.proj_contract_dbe_id,
        contractDBE
      )
      .then(response => {
        this.fetchContractDBE();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteContractDBEHandler = proj_contract_dbe_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./project_contract_dbe/" + proj_contract_dbe_id)
        .then(response => {
          this.fetchContractDBE();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
 ContractATC Claim
  */

  fetchContractClaim = () => {
    axiosInstance
      .get("/proj_contract_claim/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          contractClaim: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addContractClaimHandler = contractClaim => {
    axiosInstance
      .post("/proj_contract_claim", contractClaim)
      .then(response => {
        this.fetchContractClaim();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateContractClaimHandler = contractClaim => {
    axiosInstance
      .put(
        "/proj_contract_claim/" + contractClaim.proj_contract_claim_id,
        contractClaim
      )
      .then(response => {
        this.fetchContractClaim();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteContractClaimHandler = project_contract_claim_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./proj_contract_claim/" + project_contract_claim_id)
        .then(response => {
          this.fetchContractClaim();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
 ContractATC
  */

  fetchContractATC = () => {
    axiosInstance
      .get("/proj_contract_atc/")
      .then(response => {
        this.setState({
          contractATC: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addContractATCHandler = contractATC => {
    axiosInstance
      .post("/proj_contract_atc", contractATC)
      .then(response => {
        this.fetchContractATC();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateContractATCHandler = contractATC => {
    axiosInstance
      .put(
        "/proj_contract_atc/" + contractATC.proj_contract_atc_id,
        contractATC
      )
      .then(response => {
        this.fetchContractATC();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteContractATCHandler = project_contract_atc_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./proj_contract_atc/" + project_contract_atc_id)
        .then(response => {
          this.fetchContractATC();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
  Contract
   */

  fetchContract = () => {
    axiosInstance
      .get("/proj_contract/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          contract: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addContractHandler = contract => {
    axiosInstance
      .post("/proj_contract", contract)
      .then(response => {
        this.fetchContract();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateContractHandler = contract => {
    axiosInstance
      .put("/proj_contract/" + contract.proj_contract_id, contract)
      .then(response => {
        this.fetchContract();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteContractHandler = project_contract_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./proj_contract/" + project_contract_id)
        .then(response => {
          this.fetchContract();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
   * News
   */

  fetchNews = () => {
    axiosInstance
      .get("/project_news/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          news: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addNewsHandler = news => {
    axiosInstance
      .post("/project_news", news)
      .then(response => {
        this.fetchNews();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateNewsHandler = news => {
    axiosInstance
      .put("/project_news/" + news.project_news_id, news)
      .then(response => {
        this.fetchNews();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteNewsHandler = project_news_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./project_news/" + project_news_id)
        .then(response => {
          this.fetchNews();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
   * DBE
   */

  fetchDBE = () => {
    axiosInstance
      .get("/project_dbe/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          dbe: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addDBEHandler = dbe => {
    axiosInstance
      .post("/project_dbe", dbe)
      .then(response => {
        this.fetchDBE();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDBEHandler = dbe => {
    axiosInstance
      .put("/project_dbe/" + dbe.project_dbe_id, dbe)
      .then(response => {
        this.fetchDBE();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteDBEHandler = project_dbe_id => {
    axiosInstance
      .delete("./project_dbe/" + project_dbe_id)
      .then(response => {
        this.fetchDBE();
      })
      .catch(error => {
        console.log(error);
      });
  };

  /*
   * Stakeholder
   */

  fetchStakeholder = () => {
    axiosInstance
      .get("/project_stakeholder/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          stakeholder: response.data ? response.data : []
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addStakeholderHandler = stakeholder => {
    axiosInstance
      .post("/project_stakeholder", stakeholder)
      .then(response => {
        this.fetchStakeholder();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateStakeholderHandler = stakeholder => {
    axiosInstance
      .put(
        "/project_stakeholder/" + stakeholder.project_stakeholder_id,
        stakeholder
      )
      .then(response => {
        this.fetchStakeholder();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteStakeholderHandler = project_stakeholder_id => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./project_stakeholder/" + project_stakeholder_id)
        .then(response => {
          this.fetchStakeholder();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  /*
   * Procurement
   */

  fetchProcurement = () => {
    axiosInstance
      .get("/proj_procurement/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          procurement: response.data[0] ? response.data[0] : null
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addProcurementHandler = procurement => {
    axiosInstance
      .post("/proj_procurement", procurement)
      .then(response => {
        this.fetchProcurement();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateProcurementHandler = procurement => {
    axiosInstance
      .put("/proj_procurement/" + procurement.proj_procurement_id, procurement)
      .then(response => {
        this.fetchProcurement();
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteProcurementHandler = proj_procurement_id => {
    axiosInstance
      .delete("./proj_implementation/" + proj_procurement_id)
      .then(response => {
        this.fetchProcurement();
      })
      .catch(error => {
        console.log(error);
      });
  };

  /*
   *Dev P3 BPSC Cost
   */

  fetchDevP3BpscCost = () => {
    Promise.all([
      axiosInstance.get(
        `get_proj_dev_p3_bpsc_cost_by_Data_status_and_user_id/1/${userID}`
      ),
      axiosInstance.get("proj_dev_p3_bpsc_cost_by_data_status/2"),
      axiosInstance.get("proj_dev_p3_bpsc_cost_by_data_status/3")
    ])
      .then(([draft, submitted, published]) => {
        this.setState({
          devP3BpscCost: draft.data
            .concat(submitted.data)
            .concat(published.data)
            .filter(item => item.project_id === this.state.currentProjectID)
        });
      })
      .catch(error => {
        this.setState({
          devP3BpscCost: []
        });
        console.log(error);
      });
  };

  draftDevP3BpscCostHandler = cost => {
    axiosInstance
      .post("/proj_dev_p3_bpsc_cost_draft/", cost)
      .then(response => {
        this.fetchDevP3BpscCost(cost.project_id);
      })
      .catch(error => {
        this.setState({
          devP3BpscCost: []
        });
        console.log(error);
      });
  };

  submitDevP3BpscCostHandler = cost => {
    axiosInstance
      .post("/proj_dev_p3_bpsc_cost_submit/", cost)
      .then(response => {
        this.fetchDevP3BpscCost(cost.project_id);
      })
      .catch(error => {
        this.setState({
          devP3BpscCost: []
        });
        console.log(error);
      });
  };

  auditDevP3BpscCostHandler = cost => {
    axiosInstance
      .post("/audit_proj_dev_p3_bpsc_cost/" + cost.proj_dev_p3_bpsc_cost_id)
      .then(response => {
        this.fetchDevP3BpscCost(cost.project_id);
      })
      .catch(error => {
        this.setState({
          devP3BpscCost: []
        });
        console.log(error);
      });
  };

  updatePublishedDevP3BpscCostHandler = cost => {
    axiosInstance
      .post(
        "/edit_published_proj_dev_p3_bpsc_cost/" +
          cost.proj_dev_p3_bpsc_cost_id,
        cost
      )
      .then(response => {
        this.fetchDevP3BpscCost(cost.project_id);
      })
      .catch(error => {
        this.setState({
          devP3BpscCost: []
        });
        console.log(error);
      });
  };

  updateDraftDevP3BpscCostHandler = cost => {
    axiosInstance
      .post(
        "/edit_draft_proj_dev_p3_bpsc_cost/" + cost.proj_dev_p3_bpsc_cost_id,
        cost
      )
      .then(response => {
        this.fetchDevP3BpscCost(cost.project_id);
      })
      .catch(error => {
        this.setState({
          devP3BpscCost: []
        });
        console.log(error);
      });
  };

  updateDraftDevP3BpscCostAndSubmitHandler = cost => {
    axiosInstance
      .post(
        "/edit_draft_proj_dev_p3_bpsc_cost_and_submit/" +
          cost.proj_dev_p3_bpsc_cost_id,
        cost
      )
      .then(response => {
        this.fetchDevP3BpscCost(cost.project_id);
      })
      .catch(error => {
        this.setState({
          devP3BpscCost: []
        });
        console.log(error);
      });
  };

  /*
   *Dev P3 Alternative Cost
   */

  fetchDevP3AlternativeCost = () => {
    Promise.all([
      axiosInstance.get(
        `get_proj_dev_p3_alternative_cost_by_Data_status_and_user_id/1/${userID}`
      ),
      axiosInstance.get("proj_dev_p3_alternative_cost_by_data_status/2"),
      axiosInstance.get("proj_dev_p3_alternative_cost_by_data_status/3")
    ])
      .then(([draft, submitted, published]) => {
        this.setState({
          devP3AlternativeCost: draft.data
            .concat(submitted.data)
            .concat(published.data)
            .filter(item => item.project_id === this.state.currentProjectID)
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  draftDevP3AlternativeCostHandler = cost => {
    axiosInstance
      .post("/proj_dev_p3_alternative_cost_draft/", cost)
      .then(response => {
        this.fetchDevP3AlternativeCost(cost.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  submitDevP3AlternativeCostHandler = cost => {
    axiosInstance
      .post("/proj_dev_p3_alternative_cost_submit/", cost)
      .then(response => {
        this.fetchDevP3AlternativeCost(cost.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  auditDevP3AlternativeCostHandler = cost => {
    axiosInstance
      .post(
        "/audit_proj_dev_p3_alternative_cost/" +
          cost.proj_dev_p3_alternative_cost_id
      )
      .then(response => {
        this.fetchDevP3AlternativeCost(cost.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updatePublishedDevP3AlternativeCostHandler = cost => {
    axiosInstance
      .post(
        "/edit_published_proj_dev_p3_alternative_cost/" +
          cost.proj_dev_p3_alternative_cost_id,
        cost
      )
      .then(response => {
        this.fetchDevP3AlternativeCost(cost.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftDevP3AlternativeCostHandler = cost => {
    axiosInstance
      .post(
        "edit_draft_proj_dev_p3_alternative_cost/" +
          cost.proj_dev_p3_alternative_cost_id,
        cost
      )
      .then(response => {
        this.fetchDevP3AlternativeCost(cost.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftDevP3AlternativeCostAndSubmitHandler = cost => {
    axiosInstance
      .post(
        "edit_draft_proj_dev_p3_alternative_cost_and_submit/" +
          cost.proj_dev_p3_alternative_cost_id,
        cost
      )
      .then(response => {
        this.fetchDevP3AlternativeCost(cost.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  /*
        Cost
     */

  fetchCost = () => {
    Promise.all([
      axiosInstance.get(
        `get_project_cost_by_Data_status_and_user_id/1/${userID}`
      ),
      axiosInstance.get("project_cost_by_data_status/2"),
      axiosInstance.get("project_cost_by_data_status/3"),
      axiosInstance.get("/cost_name_type_lkp/")
    ])
      .then(([draft, submitted, published, costNameType]) => {
        this.setState({
          cost: draft.data
            .concat(submitted.data)
            .concat(published.data)
            .filter(item => item.project_id === this.state.currentProjectID),
          costNameType: costNameType.data
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  draftCostHandler = cost => {
    axiosInstance
      .post("/project_cost_draft/", cost)
      .then(response => {
        this.fetchCost();
      })
      .catch(error => {
        console.log(error);
      });
  };

  submitCostHandler = cost => {
    axiosInstance
      .post("/project_cost_submit/", cost)
      .then(response => {
        this.fetchCost();
      })
      .catch(error => {
        console.log(error);
      });
  };

  auditCostHandler = cost => {
    axiosInstance
      .post("/audit_project_cost/" + cost.project_cost_id)
      .then(response => {
        this.fetchCost();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updatePublishedCostHandler = cost => {
    axiosInstance
      .post("/edit_published_project_cost/" + cost.project_cost_id, cost)
      .then(response => {
        this.fetchCost();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftCostHandler = cost => {
    axiosInstance
      .post("edit_draft_project_cost/" + cost.project_cost_id, cost)
      .then(response => {
        this.fetchCost();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftCostAndSubmitHandler = cost => {
    axiosInstance
      .post("edit_draft_project_cost_and_submit/" + cost.project_cost_id, cost)
      .then(response => {
        this.fetchCost();
      })
      .catch(error => {
        console.log(error);
      });
  };

  /*
   *implementation Design Construction Cost
   */

  fetchImplementationDesignConstructionCost = impleID => {
    Promise.all([
      axiosInstance.get(
        `get_proj_impl_design_construction_cost_by_Data_status_and_user_id/1/${userID}`
      ),
      axiosInstance.get("proj_impl_design_construction_cost_by_data_status/2"),
      axiosInstance.get("proj_impl_design_construction_cost_by_data_status/3")
    ])
      .then(([draft, submitted, published]) => {
        this.setState({
          implementationDesignConstructionCost: draft.data
            .concat(submitted.data)
            .concat(published.data)
            .filter(item => item.proj_implementation_id === impleID)
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  draftImplementationDesignConstructionCostHandler = cost => {
    axiosInstance
      .post("/proj_impl_design_construction_cost_draft/", cost)
      .then(response => {
        this.fetchImplementationDesignConstructionCost(
          cost.proj_implementation_id
        );
      })
      .catch(error => {
        console.log(error);
      });
  };

  submitImplementationDesignConstructionCostHandler = cost => {
    axiosInstance
      .post("/proj_impl_design_construction_cost_submit/", cost)
      .then(response => {
        this.fetchImplementationDesignConstructionCost(
          cost.proj_implementation_id
        );
      })
      .catch(error => {
        console.log(error);
      });
  };

  auditImplementationDesignConstructionCostHandler = cost => {
    axiosInstance
      .post(
        "/audit_proj_impl_design_construction_cost/" +
          cost.proj_impl_design_construction_cost_id
      )
      .then(response => {
        this.fetchImplementationDesignConstructionCost(
          cost.proj_implementation_id
        );
      })
      .catch(error => {
        console.log(error);
      });
  };

  updatePublishedImplementationDesignConstructionCostHandler = cost => {
    axiosInstance
      .post(
        "/edit_published_proj_impl_design_construction_cost/" +
          cost.proj_impl_design_construction_cost_id,
        cost
      )
      .then(response => {
        this.fetchImplementationDesignConstructionCost(
          cost.proj_implementation_id
        );
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftImplementationDesignConstructionCostHandler = cost => {
    axiosInstance
      .post(
        "/edit_draft_proj_impl_design_construction_cost/" +
          cost.proj_impl_design_construction_cost_id,
        cost
      )
      .then(response => {
        this.fetchImplementationDesignConstructionCost(
          cost.proj_implementation_id
        );
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftImplementationDesignConstructionCostAndSubmitHandler = cost => {
    axiosInstance
      .post(
        "/edit_draft_proj_impl_design_construction_cost_and_submit/" +
          cost.proj_impl_design_construction_cost_id,
        cost
      )
      .then(response => {
        this.fetchImplementationDesignConstructionCost(
          cost.proj_implementation_id
        );
      })
      .catch(error => {
        console.log(error);
      });
  };

  /*
   *implementation Actual Cost
   */

  fetchImplementationActualCost = impleID => {
    Promise.all([
      axiosInstance.get(
        `get_proj_impl_actual_cost_by_Data_status_and_user_id/1/${userID}`
      ),
      axiosInstance.get("proj_impl_actual_cost_by_data_status/2"),
      axiosInstance.get("proj_impl_actual_cost_by_data_status/3")
    ])
      .then(([draft, submitted, published]) => {
        this.setState({
          implementationActualCost: draft.data
            .concat(submitted.data)
            .concat(published.data)
            .filter(item => item.proj_implementation_id === impleID)
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  draftImplementationActualCostDHandler = cost => {
    axiosInstance
      .post("/proj_impl_actual_cost_draft/", cost)
      // axiosInstance.get('/proj_impl_actual_cost')
      .then(response => {
        this.fetchImplementationActualCost(cost.proj_implementation_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  submitImplementationActualCostHandler = cost => {
    axiosInstance
      .post("/proj_impl_actual_cost_submit/", cost)
      // axiosInstance.get('/proj_impl_actual_cost')
      .then(response => {
        this.fetchImplementationActualCost(cost.proj_implementation_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  auditImplementationActualCostHandler = cost => {
    axiosInstance
      .post("/audit_proj_impl_actual_cost/" + cost.proj_impl_actual_cost_id)
      // axiosInstance.get('/proj_impl_actual_cost')
      .then(response => {
        this.fetchImplementationActualCost(cost.proj_implementation_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updatePublishedImplementationActualCostHandler = cost => {
    axiosInstance
      .post(
        "/edit_published_proj_impl_actual_cost/" +
          cost.proj_impl_actual_cost_id,
        cost
      )
      // axiosInstance.get('/proj_impl_actual_cost')
      .then(response => {
        this.fetchImplementationActualCost(cost.proj_implementation_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftImplementationActualCostHandler = cost => {
    axiosInstance
      .post(
        "/edit_draft_proj_impl_actual_cost/" + cost.proj_impl_actual_cost_id,
        cost
      )
      // axiosInstance.get('/proj_impl_actual_cost')
      .then(response => {
        this.fetchImplementationActualCost(cost.proj_implementation_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftImplementationActualCostAndSubmitHandler = cost => {
    axiosInstance
      .post(
        "/edit_draft_proj_impl_actual_cost_and_submit/" +
          cost.proj_impl_actual_cost_id,
        cost
      )
      // axiosInstance.get('/proj_impl_actual_cost')
      .then(response => {
        this.fetchImplementationActualCost(cost.proj_implementation_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  toggleSmallModalHandler = () => {
    this.setState(prevState => {
      return {
        showSmallModal: !prevState.showSmallModal
      };
    });
  };

  fetchImple = () => {
    axiosInstance
      .get("/proj_implementation/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          implementation: response.data
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addImpleHandler = imple => {
    axiosInstance
      .post("/proj_implementation", imple)
      .then(response => {
        this.fetchImple(imple.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateImpleHandler = imple => {
    axiosInstance
      .put("/proj_implementation/" + imple.proj_implementation_id, imple)
      .then(response => {
        this.fetchImple(imple.project_id);
        this.setState({
          showSmallModal: false
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteImpleHandler = (impleID, projectID) => {
    axiosInstance
      .delete("./proj_implementation/" + impleID)
      .then(response => {
        this.fetchImple(projectID);
      })
      .catch(error => {
        console.log(error);
      });
  };

  fetchAADT = () => {
    axiosInstance
      .get("/project_aadt/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          aadt: response.data
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addAADTHandler = aadt => {
    axiosInstance
      .post("/project_aadt", aadt)
      .then(response => {
        this.fetchAADT(aadt.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateAADTHandler = aadt => {
    axiosInstance
      .post("/project_aadt", aadt)
      .then(response => {
        this.fetchAADT(aadt.project_id);
        this.setState({
          showSmallModal: false
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteAADTHandler = (aadtID, projectID) => {
    axiosInstance
      .delete("./project_aadt/" + aadtID)
      .then(response => {
        this.fetchAADT(projectID);
      })
      .catch(error => {
        console.log(error);
      });
  };

  fetchProjectDetails = () => {
    if (localStorage.getItem("role")) {
      let role = JSON.parse(localStorage.getItem("role")).map(
        role => role.name
      );

      if (role.includes("ROLE_ADMIN")) {
        axiosInstance
          .get("/projectdetail")
          .then(response => {
            /*const user_id =
                localStorage.getItem("id") !== null
                  ? parseInt(localStorage.getItem("id"))
                  : null;*/
            this.setState(prevState => {
              return {
                //TODO: the filter function cost a long long time
                // projectDetails: response.data.filter(project => {
                //     return project.data_status.name !== 'Draft' || (project.data_status.name === 'Draft' && project.created_by === user_id)
                // }),
                projectDetails: response.data
              };
            });
            let temp = this.state.projectDetails.slice();

            temp.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({ projectDetails: temp });
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        axiosInstance
          .get("/user/me")
          .then(response => {
            if (response.data.states) {
              let states = response.data.states.map(state => state.state_id);
              let requests = [];
              for (let i in states) {
                requests.push(
                  axiosInstance.get("/projectdetail/state_id/" + states[i])
                );
              }
              Promise.all(requests)
                .then(responseList => {
                  /*const user_id =
                        localStorage.getItem("id") !== null
                          ? parseInt(localStorage.getItem("id"))
                          : null;*/
                  let temp = [];
                  let ids = new Set();
                  for (let i in responseList) {
                    for (let j in responseList[i].data) {
                      if (
                        responseList[i].data[j] &&
                        !ids.has(responseList[i].data[j].project_id)
                      ) {
                        temp.push(responseList[i].data[j]);
                        ids.add(responseList[i].data[j].project_id);
                      }
                    }
                  }

                  temp.sort((a, b) => (a.name > b.name ? 1 : -1));
                  this.setState({ projectDetails: temp });
                })
                .catch(error => {
                  console.log(error);
                });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  };

  fetchDocuments = () => {
    axiosInstance
      .get("/project_file/project_id/" + this.state.currentProjectID)
      .then(response => {
        this.setState({
          projectDocuments: response.data
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addDocumentsHandler = documentInfo => {
    axiosInstance
      .post("/project_file", documentInfo)
      .then(response => {
        this.fetchDocuments(documentInfo.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDocumentHandler = documentInfo => {
    console.log(JSON.stringify(documentInfo));
    axiosInstance
      .put("/project_file/" + documentInfo.project_file_id, documentInfo)
      .then(response => {
        this.fetchDocuments(documentInfo.project_id);
      })
      .catch(error => {
        console.log(error);
      });
  };

  deleteDocumentHandler = projectFileId => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("/project_file/" + projectFileId)
        .then(response => {
          this.fetchDocuments();
        })
        .catch(error => {
          console.log(error);
        })
    );
  };

  componentDidMount() {
    this.updateProjectDetails();
    window.onpopstate = e => {
      this.closeModalHandler();
    };
    this.changeModeHandler(
      Number.parseInt(localStorage.getItem("project_mode") || 3)
    );
  }

  updateProjectDetails = () => {
    const url = `${this.state.baseURL}/security/api/projectdetail`;
    this.fetchProjectDetails(url);
  };

  closeModalHandler = () => {
    this.setState({
      showModal: false,
      showSmallModal: false
    });
  };

  toggleModalHandler = projectID => {
    this.setState(prevState => {
      return {
        showModal: true,
        currentProjectID: projectID
      };
    });
  };

  submitBasicInfoDraftHandler = projectDetail => {
    axiosInstance
      .post(`/project_draft`, projectDetail)
      .then(response => {
        this.updateProjectDetails();
        this.setState({
          currentProjectID: response.data.project_id
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  auditBasicInfoHandler = () => {
    axiosInstance
      .post("/audit_project/" + this.state.currentProjectID)
      .then(response => {
        this.updateProjectDetails();
      })
      .catch(error => {
        console.log(error);
      });
  };

  submitBasicInfoHandler = projectDetail => {
    axiosInstance
      .post(`/project_submit`, projectDetail)
      .then(response => {
        this.updateProjectDetails();
        this.setState({
          currentProjectID: response.data.project_id
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  updatePublishedBasicInfoHandler = projectDetail => {
    axiosInstance
      .post(
        `/edit_published_project/${projectDetail.project_id}`,
        projectDetail
      )
      .then(response => {
        this.updateProjectDetails();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftBasicInfoHandler = projectDetail => {
    axiosInstance
      .post(`/edit_draft_project/${projectDetail.project_id}`, projectDetail)
      .then(response => {
        this.updateProjectDetails();
      })
      .catch(error => {
        console.log(error);
      });
  };

  updateDraftBasicInfoAndSubmitHandler = projectDetail => {
    axiosInstance
      .post(
        `/edit_draft_project_and_submit/${projectDetail.project_id}`,
        projectDetail
      )
      .then(response => {
        this.updateProjectDetails();
      })
      .catch(error => {
        console.log(error);
      });
  };

  unpublishBasicInfoHandler = projectDetail => {
    axiosInstance
      .post(`/unpublish_project/${projectDetail.project_id}`, projectDetail)
      .then(response => {
        this.updateProjectDetails();
      })
      .catch(error => {
        console.log(error);
      });
  };

  createNewProject = () => {
    this.setState({
      projectDocuments: [],
      showModal: true,
      currentProjectID: null
    });
  };

  render() {
    let modal = null;
    const role = localStorage.getItem("project_role");
    if (this.state.showModal) {
      modal = (
        <Modal>
          <ProjectModal
            //#insert point: props pass
            closeModal={this.closeModalHandler}
            devEnvironmentReview={{
              devEnvironmentReview: this.state.devEnvironmentReview,
              fetch: this.fetchDevEnvironmentReview,
              add: this.addDevEnvironmentReviewHandler,
              update: this.updateDevEnvironmentReviewHandler,
              delete: this.deleteDevEnvironmentReviewHandler
            }}
            devFeisCostEstimate={{
              devFeisCostEstimate: this.state.devFeisCostEstimate,
              fetch: this.fetchDevFeisCostEstimate,
              add: this.addDevFeisCostEstimateHandler,
              update: this.updateDevFeisCostEstimateHandler,
              delete: this.deleteDevFeisCostEstimateHandler
            }}
            contractQualityAssurance={{
              contractQualityAssurance: this.state.contractQualityAssurance,
              fetch: this.fetchContractQualityAssurance,
              add: this.addContractQualityAssuranceHandler,
              update: this.updateContractQualityAssuranceHandler,
              delete: this.deleteContractQualityAssuranceHandler
            }}
            contractChangeOrder={{
              contractChangeOrder: this.state.contractChangeOrder,
              fetch: this.fetchContractChangeOrder,
              add: this.addContractChangeOrderHandler,
              update: this.updateContractChangeOrderHandler,
              delete: this.deleteContractChangeOrderHandler
            }}
            contractWorkZone={{
              contractWorkZone: this.state.contractWorkZone,
              fetch: this.fetchContractWorkZone,
              add: this.addContractWorkZoneHandler,
              update: this.updateContractWorkZoneHandler,
              delete: this.deleteContractWorkZoneHandler
            }}
            contractDBE={{
              contractDBE: this.state.contractDBE,
              fetch: this.fetchContractDBE,
              add: this.addContractDBEHandler,
              update: this.updateContractDBEHandler,
              delete: this.deleteContractDBEHandler
            }}
            implementationActualCost={{
              cost: this.state.implementationActualCost,
              fetch: this.fetchImplementationActualCost,
              draft: this.draftImplementationActualCostDHandler,
              submit: this.submitImplementationActualCostHandler,
              audit: this.auditImplementationActualCostHandler,
              update: this.updatePublishedImplementationActualCostHandler,
              updateDraft: this.updateDraftImplementationActualCostHandler,
              updateDraftAndSubmit: this
                .updateDraftImplementationActualCostAndSubmitHandler
            }}
            implementationDesignConstructionCost={{
              cost: this.state.implementationDesignConstructionCost,
              fetch: this.fetchImplementationDesignConstructionCost,
              draft: this.draftImplementationDesignConstructionCostHandler,
              submit: this.submitImplementationDesignConstructionCostHandler,
              audit: this.auditImplementationDesignConstructionCostHandler,
              update: this
                .updatePublishedImplementationDesignConstructionCostHandler,
              updateDraft: this
                .updateDraftImplementationDesignConstructionCostHandler,
              updateDraftAndSubmit: this
                .updateDraftImplementationDesignConstructionCostAndSubmitHandler
            }}
            devP3AlternativeCost={{
              cost: this.state.devP3AlternativeCost,
              fetch: this.fetchDevP3AlternativeCost,
              draft: this.draftDevP3AlternativeCostHandler,
              submit: this.submitDevP3AlternativeCostHandler,
              audit: this.auditDevP3AlternativeCostHandler,
              update: this.updatePublishedDevP3AlternativeCostHandler,
              updateDraft: this.updateDraftDevP3AlternativeCostHandler,
              updateDraftAndSubmit: this
                .updateDraftDevP3AlternativeCostAndSubmitHandler
            }}
            devP3BpscCost={{
              cost: this.state.devP3BpscCost,
              fetch: this.fetchDevP3BpscCost,
              draft: this.draftDevP3BpscCostHandler,
              submit: this.submitDevP3BpscCostHandler,
              audit: this.auditDevP3BpscCostHandler,
              update: this.updatePublishedDevP3BpscCostHandler,
              updateDraft: this.updateDraftDevP3BpscCostHandler,
              updateDraftAndSubmit: this
                .updateDraftDevP3BpscCostAndSubmitHandler
            }}
            cost={{
              cost: this.state.cost,
              costNameType: this.state.costNameType,
              fetch: this.fetchCost,
              draft: this.draftCostHandler,
              submit: this.submitCostHandler,
              audit: this.auditCostHandler,
              update: this.updatePublishedCostHandler,
              updateDraft: this.updateDraftCostHandler,
              updateDraftAndSubmit: this.updateDraftCostAndSubmitHandler
            }}
            showSmallModal={this.state.showSmallModal}
            toggleSmallModalHandler={this.toggleSmallModalHandler}
            basicInfoDraft={projID => this.submitBasicInfoDraftHandler(projID)}
            basicInfoSubmit={projID => this.submitBasicInfoHandler(projID)}
            basicInfoPublishedUpdate={projID =>
              this.updatePublishedBasicInfoHandler(projID)
            }
            basicInfoDraftUpdate={projID =>
              this.updateDraftBasicInfoHandler(projID)
            }
            basicInfoDraftUpdateAndSubmit={projID =>
              this.updateDraftBasicInfoAndSubmitHandler(projID)
            }
            basicInfoUnpublish={projID =>
              this.unpublishBasicInfoHandler(projID)
            }
            basicInfoAudit={this.auditBasicInfoHandler}
            closed={this.closeModalHandler}
            projectItems={this.state.projectDetails}
            documents={{
              documents: this.state.projectDocuments,
              fetch: this.fetchDocuments,
              add: this.addDocumentsHandler,
              update: this.updateDocumentHandler,
              delete: this.deleteDocumentHandler
            }}
            procurement={{
              procurement: this.state.procurement,
              fetch: this.fetchProcurement,
              add: this.addProcurementHandler,
              update: this.updateProcurementHandler,
              delete: this.deleteProcurementHandler
            }}
            stakeholder={{
              stakeholder: this.state.stakeholder,
              fetch: this.fetchStakeholder,
              add: this.addStakeholderHandler,
              update: this.updateStakeholderHandler,
              delete: this.deleteStakeholderHandler
            }}
            aadt={{
              update: this.updateAADTHandler,
              aadt: this.state.aadt,
              fetch: this.fetchAADT,
              add: this.addAADTHandler,
              delete: this.deleteAADTHandler
            }}
            contract={{
              update: this.updateContractHandler,
              contract: this.state.contract,
              fetch: this.fetchContract,
              add: this.addContractHandler,
              delete: this.deleteContractHandler
            }}
            contractClaim={{
              update: this.updateContractClaimHandler,
              contractClaim: this.state.contractClaim,
              fetch: this.fetchContractClaim,
              add: this.addContractClaimHandler,
              delete: this.deleteContractClaimHandler
            }}
            contractATC={{
              update: this.updateContractATCHandler,
              contractATC: this.state.contractATC,
              fetch: this.fetchContractATC,
              add: this.addContractATCHandler,
              delete: this.deleteContractATCHandler
            }}
            imple={{
              updateImple: this.updateImpleHandler,
              implementation: this.state.implementation,
              fetchImple: this.fetchImple,
              addImple: this.addImpleHandler,
              deleteImple: this.deleteImpleHandler
            }}
            dbe={{
              dbe: this.state.dbe,
              fetch: this.fetchDBE,
              add: this.addDBEHandler,
              update: this.updateDBEHandler,
              delete: this.deleteDBEHandler
            }}
            news={{
              news: this.state.news,
              fetch: this.fetchNews,
              add: this.addNewsHandler,
              update: this.updateNewsHandler,
              delete: this.deleteNewsHandler
            }}
            currentProjectID={this.state.currentProjectID}
          />
        </Modal>
      );
    }

    return (
      <Aux>
        {this.state.showModal ? (
          modal
        ) : (
          <Aux>
            <div style={{ textAlign: "right" }}>
              <button
                className={"btn btn-outline-primary btn-sm my-2"}
                type="button"
                onClick={() => {
                  this.props.history.push("/project/detail");
                  this.createNewProject();
                }}
              >
                Create new Project
              </button>
            </div>
            <Tabs selectedIndex={this.state.mode ? 3 - this.state.mode : 0}>
              <TabList>
                <Tab onClick={() => this.changeModeHandler(3)}>Published</Tab>
                {role === "ROLE_USER" ? null : (
                  <Tab onClick={() => this.changeModeHandler(2)}>
                    Pending Approval
                  </Tab>
                )}

                <Tab onClick={() => this.changeModeHandler(1)}>Draft</Tab>
              </TabList>

              <TabPanel></TabPanel>
              {role === "ROLE_USER" ? null : <TabPanel></TabPanel>}
              <TabPanel></TabPanel>
            </Tabs>
            <ProjectTable
              mode={this.state.mode}
              clicked={this.toggleModalHandler}
              projectItems={this.state.projectDetails}
              createNewProject={this.createNewProject}
              page={this.state.page}
              changePage={this.changePage}
            />
          </Aux>
        )}
      </Aux>
    );
  }
}

export default withRouter(ProjectOverview);
